var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3125 4.5625H11.0625C11.1785 4.5625 11.2898 4.60859 11.3719 4.69064C11.4539 4.77269 11.5 4.88397 11.5 5C11.5 5.11603 11.4539 5.22731 11.3719 5.30936C11.2898 5.39141 11.1785 5.4375 11.0625 5.4375H2.3125C2.19647 5.4375 2.08519 5.39141 2.00314 5.30936C1.92109 5.22731 1.875 5.11603 1.875 5C1.875 4.88397 1.92109 4.77269 2.00314 4.69064C2.08519 4.60859 2.19647 4.5625 2.3125 4.5625Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.55691 4.99958L5.18553 8.62733C5.26768 8.70948 5.31383 8.8209 5.31383 8.93708C5.31383 9.05326 5.26768 9.16468 5.18553 9.24683C5.10338 9.32898 4.99196 9.37513 4.87578 9.37513C4.7596 9.37513 4.64818 9.32898 4.56603 9.24683L0.628532 5.30933C0.587789 5.26869 0.555464 5.22041 0.533409 5.16726C0.511353 5.1141 0.5 5.05712 0.5 4.99958C0.5 4.94203 0.511353 4.88505 0.533409 4.8319C0.555464 4.77875 0.587789 4.73047 0.628532 4.68983L4.56603 0.752326C4.64818 0.670175 4.7596 0.624023 4.87578 0.624023C4.99196 0.624023 5.10338 0.670175 5.18553 0.752326C5.26768 0.834477 5.31383 0.945897 5.31383 1.06208C5.31383 1.17825 5.26768 1.28968 5.18553 1.37183L1.55691 4.99958Z",
    fill: "#4285F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back_arrow.2cfbbb0188c283ace060d103ebd0f288.svg";
export { ForwardRef as ReactComponent };